<template>
  <div id="wrap">
    <ErrorMessage :status="apiStatus.status" :customMessage="apiStatus.customMessage" />

    <template v-if="apiStatus.status === 200">
      <b-container id="contents" class="my-5" fluid>
        <section>
          <b-row id="profile" align-h="center" class="mb-0">
            <b-col sm="12" md="8" class="px-0">
              <b-card :style="getPfBgDataURLData()" no-body>
                <b-card-body class="d-flex align-items-center">
                  <!--                <SHIcons id="logo" name="logo" iconColor="#F5D021" width="100%" height="100%" stroke-width="1" stroke-color="#ffffff"/>-->
                  <b-container fluid>
                    <b-row align-h="center" align-v="center">
                      <b-col class="profile-col p-3" sm="12" md="8">
                        <div class="d-flex justify-content-center justify-content-sm-start align-items-center mb-3">
                          <SHIcons v-if="!pfIcoDataURL" class="profile-icon" name="parson" width="100%" height="100%" />
                          <b-img
                            v-else
                            :src="pfIcoDataURL"
                            class="profile-icon mr-3 border"
                            width="100%"
                            height="100%"
                            rounded="circle"
                            style="object-fit: cover"
                            alt="Circle image"
                          ></b-img>
                          <b-card-title class="my-0">{{ display_name }}</b-card-title>
                        </div>
                        <div class="d-flex">
                          <div v-if="profileList.address_prefecture" class="mr-2">
                            <SHIcons name="gps" width="16" height="16" iconColor="#a2afc1" />
                            {{ profileList.address_prefecture }}
                          </div>
                          <div v-if="profileList.birth_year_month" class="d-flex">
                            <SHIcons name="birth" width="16" height="16" iconColor="#a2afc1" />
                            {{ profileList.birth_year_month }}
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </b-container>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </section>
        <section>
          <b-row v-if="introduction" id="introduction" align-h="center">
            <b-col sm="12" md="8" class="portofolio-label py-3">
              <b-card>
                <b-card-text>
                  <ElementAutoLink :text="introduction"></ElementAutoLink>
                </b-card-text>
              </b-card>
            </b-col>
          </b-row>
        </section>
      </b-container>
    </template>
    <template v-else>
      <!-- 読み込み中 or エラー -->
    </template>
  </div>
</template>

<script>
import ErrorMessage from '@/components/ErrorMessage.vue'
import SHIcons from '@/components/ico/SHIcons.vue'
import ElementAutoLink from '@/components/presentationals/ElementAutoLink.vue'
import { getErrorStatus } from '@/transformer/base'

export default {
  name: 'PersonalProfile',
  components: {
    ErrorMessage,
    SHIcons,
    ElementAutoLink
  },
  mounted() {
    this.getProfileData()
    this.$nextTick(function () {
      if (this.$route.hash.match(/^#/)) {
        document.getElementById(this.$route.hash.replace(/^#/, '')).scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      }
    })
  },
  watch: {
    $route: (to, from) => {
      if (to.hash.match(/^#/)) {
        document.getElementById(to.hash.replace(/^#/, '')).scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      }
    },
    url_string() {
      this.getProfileData()
    }
  },
  props: ['url_string'],
  data() {
    return {
      info: [],
      prefectures: [],
      pfBgDataURL: '',
      pfIcoDataURL: '',
      apiStatus: {
        status: 0,
        custumMessage: ''
      }
    }
  },
  computed: {
    display_name: function () {
      return this.info.display_name
    },
    profileList: function () {
      let tmp = ''
      let tmp2 = ''
      let tmp3 = ''
      let tmp4 = ''
      if (!this.info.address_prefecture) {
        tmp = '' // 「表示しない」
      } else if (!this.prefectures[this.info.address_prefecture]) {
        tmp = '' // プロフィールが「未登録」なので表示しない
      } else {
        tmp = this.prefectures[this.info.address_prefecture].name
      }
      if (!this.info.birth_year) {
        tmp2 = '' // 「表示しない」
      } else if (this.info.birth_year === '0') {
        tmp2 = '' // プロフィールが未設定なので表示しない
      } else {
        tmp2 = this.info.birth_year
      }
      if (!this.info.birth_month) {
        tmp3 = '' // 「表示しない」
      } else if (this.info.birth_month === '0') {
        tmp3 = '' // プロフィールが未設定なので表示しない
      } else {
        tmp3 = this.info.birth_month
      }

      if (tmp2) {
        if (tmp3) {
          tmp4 = tmp2 + '年' + tmp3 + '月'
        } else {
          tmp4 = tmp2 + '年'
        }
      } else {
        if (tmp3) {
          tmp4 = tmp3 + '月'
        } else {
          tmp4 = ''
        }
      }

      // 未登録は画面に表示しない仕様変更
      tmp = tmp === '未登録' ? '' : tmp

      const profileList = {
        address_prefecture: tmp,
        birth_year_month: tmp4
      }

      return profileList
    },
    introduction: function () {
      return this.info.introduction
    }
  },
  methods: {
    getProfileData: async function () {
      this.apiStatus.status = 0
      await this.$axios
        .get(this.$constList.apiUrl + 'profile/info_with_url_string?url_string=' + this.url_string)
        .then((res) => {
          this.apiStatus.status = res.status
          this.info = res.data.info
          this.prefectures = res.data.prefectures
          this.pfIcoDataURL = res.data.pfIcoDataURL
          this.pfBgDataURL = res.data.pfBgDataURL
          this.apiStatus.customMessage = ''
        })
        .catch((e) => {
          const errors = getErrorStatus(e)
          this.apiStatus.status = errors.status
          this.apiStatus.customMessage = '表示できるデータがありません。'
          this.apiStatus.errors = errors.errors
        })
    },
    getPfBgDataURLData() {
      return {
        minHeight: this.pfBgDataURL ? '25vh' : 'unset',
        background: `url(${this.pfBgDataURL})`,
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        borderRadius: 0,
        color: '#ffffff'
      }
    }
  }
}
</script>

<style>
@media print {
  /* ページ全体の左右の余白を削る */
  section > .row > .col-md-8 {
    width: 100%;
    max-width: 100%;
    flex-basis: 100%;
  }
}
</style>

<style scoped>
.card {
  border: 0;
}
.card,
.card * {
  break-inside: avoid;
  page-break-inside: avoid;
}

/* 改行を有効にする */
.card-text {
  font-size: 1rem;
  color: #464646;
  white-space: pre-wrap;
}

/* ラベル */
.portofolio-label {
  font-size: 1.4rem;
  text-decoration: none;
  color: #33537e;
}

#contents {
  margin-top: 0 !important;
  counter-reset: works-number 0 career-number 0;
}

#logo {
  width: 50px;
  height: 50px;
  position: absolute;
  top: 2vmax;
  left: 2vmax;
  z-index: 10;
}

/* PROFILE */

#profile .card-title {
  font-weight: bold;
}
#profile .profile-icon {
  width: 8vmax;
  max-width: 80px;
  height: 8vmax;
  max-height: 80px;
}
#profile .profile-col {
  backdrop-filter: blur(3px);
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.3);
}
</style>
